import { STATUS_MESSAGES, STATUS_CODE } from '@shared/constants';
import { AUTH_ERROR_MESSAGES, FIREBASE_ERROR_CODES } from './auth';

export const ERROR_MESSAGES = {
  FETCH_ACTION_ITEMS: 'Something went wrong while fetching action items.',
  DOWNLOAD_FILE_FAILED: 'Failed to download the file. Please try again.',
  PAGE_NOT_FOUND: 'Page not found.',
  PAGE_ERROR: `Oops! We've touched the wrong wire.`,
  FETCH_PROJECT_ACTIVITIES:
    'Something went wrong while fetching project activities.',
  FETCH_EMPLOYEE_ACTIVITIES:
    'Something went wrong while fetching employee activities.',
  FETCH_PROJECT_MEMBERS: 'Something went wrong while fetching project members.',
  CHATBOT_GENERIC_ERROR: 'Something goes wrong',

  FETCH_VIDEOS_FAILED: 'Failed to load videos. Please try again.',
  TOKEN_NOT_AVAILABLE:
    "You don't have permission to view this content. Please try again later.",

  // Employees
  NOT_FOUND_EMPLOYEE_TITLE: 'Employee not found.',
  NOT_FOUND_EMPLOYEE_SUBTITLE:
    "This employee is not available or you don't have permission to view their details.",
};

export const SEARCH_ACTION_FORM_MODAL = {
  NO_RESULTS: 'No matching result found!',
};

export const CONTENT_MESSAGE = {
  PAGE_NOT_FOUND: 'But hey, at least you found me!',
  PAGE_ERROR: 'Might wanna back off...',
};

// Error messages that should be silently ignored (no toast notification)
export const SILENT_ERROR_MESSAGES = [
  AUTH_ERROR_MESSAGES.ROLE_MISMATCH,
  STATUS_MESSAGES[STATUS_CODE.UNAUTHORIZED],
  FIREBASE_ERROR_CODES.POPUP_CLOSED,
] as const;

export const WEBSOCKET_MESSAGE = {
  CONNECT_FAILED: '[Websocket] Failed to connect to WebSocket server.',
  FAILED_TO_SEND_MESSAGE: '[Websocket] Cannot send the message',
  HANDLER_ERROR: '[Websocket] Error in event handler',
};

// Training toast messages
export const TRAINING_TOAST_MESSAGES = {
  UPDATE_SUCCESS: 'Training content updated successfully',
  SEND_REQUEST_FEEDBACK_SUCCESS: 'Request feedback sent successfully',
  UPDATE_PRESENTATION_SUCCESS: 'Presentation updated successfully',
  UPDATE_FEEDBACK_SUCCESS: 'Feedback updated successfully',
  COMMON: 'Updated successfully',
  ADD_FEEDBACK_SUCCESS: 'Feedback added successfully',
  ADD_PRESENTATION_SUCCESS: 'Presentation created successfully',
  TRAINING_CREATED_SUCCESS: 'Training created successfully.',
  TRAINING_CREATE_FAILED: 'Failed to create training. Please try again.',
  TRAINING_UPDATED_SUCCESS: 'Training updated successfully.',
  TRAINING_UPDATE_FAILED: 'Failed to update training. Please try again.',
  REVOKE_REQUEST_FEEDBACK_SUCCESS: 'Request feedback revoked successfully',
  TRAINING_ARCHIVE_SUCCESS: 'Training archived successfully',
  TRAINING_UNARCHIVE_SUCCESS: 'Training unarchived successfully',
  PRESENTATION_ARCHIVE_SUCCESS: 'Presentation archived successfully',
  PRESENTATION_UNARCHIVE_SUCCESS: 'Presentation unarchived successfully',

  // Start training messages
  TRAINING_START_LOADING: 'Starting training...',
  TRAINING_START_SUCCESS: 'Training started successfully!',
  TRAINING_START_ERROR: 'Failed to start training',

  // Pause training messages
  TRAINING_PAUSE_LOADING: 'Pausing training...',
  TRAINING_PAUSE_SUCCESS: 'Training paused successfully!',
  TRAINING_PAUSE_ERROR: 'Failed to pause training',

  // Resume training messages
  TRAINING_RESUME_LOADING: 'Resuming training...',
  TRAINING_RESUME_SUCCESS: 'Training resumed successfully!',
  TRAINING_RESUME_ERROR: 'Failed to resume training',

  // Complete training messages
  TRAINING_COMPLETE_LOADING: 'Completing training...',
  TRAINING_COMPLETE_SUCCESS: 'Training completed successfully!',
  TRAINING_COMPLETE_ERROR: 'Failed to complete training',

  // Invite supporter messages
  INVITE_SUPPORTER_LOADING: 'Inviting supporter...',
  INVITE_SUPPORTER_SUCCESS: 'Supporter invited successfully!',
  INVITE_SUPPORTER_ERROR: 'Failed to invite supporter',

  // Revoke supporter messages
  REVOKE_SUPPORTER_LOADING: 'Removing supporter...',
  REVOKE_SUPPORTER_SUCCESS: 'Supporter removed successfully!',
  REVOKE_SUPPORTER_ERROR: 'Failed to remove supporter',

  // Revoke participant messages
  REVOKE_PARTICIPANT_LOADING: 'Removing participant...',
  REVOKE_PARTICIPANT_SUCCESS: 'Participant removed successfully!',
  REVOKE_PARTICIPANT_ERROR: 'Failed to remove participant',

  // Archive training messages
  TRAINING_ARCHIVE_LOADING: 'Archiving training...',
  TRAINING_ARCHIVE_ERROR: 'Failed to archive training',

  // Unarchive training messages
  TRAINING_UNARCHIVE_LOADING: 'Unarchiving training...',
  TRAINING_UNARCHIVE_ERROR: 'Failed to unarchive training',

  // Archive presentation messages
  PRESENTATION_ARCHIVE_LOADING: 'Archiving presentation...',
  PRESENTATION_ARCHIVE_ERROR: 'Failed to archive presentation',

  // Unarchive presentation messages
  PRESENTATION_UNARCHIVE_LOADING: 'Unarchiving presentation...',
  PRESENTATION_UNARCHIVE_ERROR: 'Failed to unarchive presentation',
} as const;
